











import { Component, Vue } from 'vue-property-decorator';
import { stListSharedApi} from '@/services/st-api';

@Component({
  components: {},
})
export default class ListExternalExternal extends Vue {
  guid: string = '';
  htmlResult: string = '';
  loading: boolean = true;
  exists: boolean = true;

  created() {
    this.guid = this.$route.params.guid;
  }

  async mounted() {
    this.exists = await stListSharedApi.checkPreset(this.guid);
    if (this.exists) {
      this.htmlResult = await stListSharedApi.getHtml(this.guid);
    }
    this.loading = false;
  }
}
